/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Disclosure } from '@headlessui/react';
import { useSelector } from 'react-redux';
import ToolTip from '../../../CommonComponent/tooltip';
import config from '../../../config';
import { dataService } from '../../../services/dataService';

const NON_DRAFT_STATUSES = ['Published', 'Accepting Bids', 'Accepting bids', 'In Progress', 'Completed', 'Cancelled'];

export default function CustomUrlSection({ auctionData, vanitySlug }) {
    const planTypeFromStore = useSelector((state) => state.pricingSlice.plan_type);
    const planType = planTypeFromStore || localStorage.getItem('plan_type');
    const [sellerSubdomain, setSellerSubdomain] = useState('');

    useEffect(() => {
        const fetchSubdomain = async () => {
            const response = await dataService.SubDomainSetup('?view=True', {});
            if (response?.error === false) {
                setSellerSubdomain(response.data?.subdomain || '');
            }
        };
        fetchSubdomain();
    }, []);

    if (planType !== 'Pro' || !vanitySlug) {
        return null;
    }

    const isLocked = NON_DRAFT_STATUSES.includes(auctionData.status);
    const host = `${sellerSubdomain || 'bid'}.${config.Environment.domain}`;
    const showCustomSlugInPreview = Boolean(vanitySlug.slug) && !vanitySlug.isFormatInvalid && !vanitySlug.isTaken;
    const previewPath = showCustomSlugInPreview ? vanitySlug.slug : `auctions/${auctionData._id || 'auction-id'}`;
    const previewUrl = `https://${host}/${previewPath}`;

    return (
        <Disclosure as="div" className="px-9 pt-4 border-b pb-[24px]" defaultOpen={true}>
            {({ open }) => (
                <>
                    <Disclosure.Button className="flex justify-between w-full items-center">
                        <span className="flex items-center gap-2">
                            <p className="font-medium text-[#343434] text-[14px] leading-normal">Custom URL</p>
                            <ToolTip trigger="mouseenter"
                                content="The URL preview shows what your auction URL will be. Edit your URL path below. To customise your sub-domain, please go to your Account Settings.">
                                <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                            </ToolTip>
                        </span>
                        <img src={open ? "/images/auction-hide-dropdown.svg" : "/images/auction-show-dropdown.svg"} className="cursor-pointer header-dropdown"
                            alt="dropdown-icon" loading="lazy" />
                    </Disclosure.Button>
                    <Disclosure.Panel>
                        <div className='bg-[#FAFAFA] rounded-md p-3 mt-[28px] border border-[#A1A1A9]'>
                            <div>
                                <p className="font-medium text-[#343434] mb-1 text-[12px] leading-normal">URL preview</p>
                                <p className="border border-[#A1A1A9] p-2 bg-[#F4F4F5] rounded text-[12px] font-medium leading-normal text-[#343434] break-all">{previewUrl}</p>
                            </div>
                            {!isLocked && <div className="pt-3">
                                <label htmlFor="vanity_slug" className="font-medium text-[#343434] text-[12px] leading-normal">Edit your URL path </label>
                                <input autoComplete='off' type="text" value={vanitySlug.slug} id='vanity_slug' className="border border-[#A1A1A9] w-full p-2 outline-none text-[14px] leading-normal
                            font-medium text-[#343434] placeholder:text-[#A1A1A9] rounded" placeholder="e.g., benefit-auction" maxLength={50} onChange={(e) => vanitySlug.handleSlugChange(e.target.value)} />
                                {vanitySlug.checkingSlug && <p className="text-[10px] pt-1.5 font-medium leading-normal text-[#A1A1A9]">Checking availability...</p>}
                                {!vanitySlug.checkingSlug && vanitySlug.slugError && <p className="text-[10px] pt-1.5 font-medium leading-normal error-msg text-[#984848]">{vanitySlug.slugError}</p>}
                                {!vanitySlug.checkingSlug && !vanitySlug.slugError && vanitySlug.slugSuccess && <p className="text-[10px] pt-1.5 font-medium leading-normal text-[#3E8E5A]">{vanitySlug.slugSuccess}</p>}
                            </div>}
                        </div>
                    </Disclosure.Panel>
                </>
            )}
        </Disclosure>
    );
}
